/**
 * Phase 105-Agent-A — PickupDropPolyline.
 *
 * Draws a pickup → drop polyline for the selected task. Tries OSRM for
 * the road geometry; falls back to a dashed straight line if OSRM is
 * unreachable. Always renders SOMETHING so the selected task feels
 * connected on the map.
 */
import { useEffect, useState } from "react";
import { Polyline } from "../tracking/mapProvider";

function pickupLatLng(o) {
  const lat = o?.pickup_location?.lat ?? o?.pickup_lat;
  const lng = o?.pickup_location?.lng ?? o?.pickup_lng;
  if (lat == null || lng == null) return null;
  return [Number(lat), Number(lng)];
}
function dropLatLng(o) {
  const lat = o?.delivery_location?.lat ?? o?.delivery_lat;
  const lng = o?.delivery_location?.lng ?? o?.delivery_lng;
  if (lat == null || lng == null) return null;
  return [Number(lat), Number(lng)];
}

export default function PickupDropPolyline({ task }) {
  const pickup = pickupLatLng(task);
  const drop = dropLatLng(task);
  const [route, setRoute] = useState([]);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    setRoute([]); setFallback(false);
    if (!pickup || !drop) return;
    let cancelled = false;
    fetch(`https://router.project-osrm.org/route/v1/driving/${pickup[1]},${pickup[0]};${drop[1]},${drop[0]}?overview=full&geometries=geojson`)
      .then((r) => r.json())
      .then((d) => {
        if (cancelled) return;
        if (d.code === "Ok" && d.routes?.[0]) {
          setRoute(d.routes[0].geometry.coordinates.map(([lng, lat]) => [lat, lng]));
        } else { setFallback(true); }
      })
      .catch(() => { if (!cancelled) setFallback(true); });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task?.tracking_id]);

  if (!pickup || !drop) return null;
  if (route.length > 0) {
    return <Polyline positions={route} pathOptions={{ color: "#FF6B00", weight: 4, opacity: 0.85 }} />;
  }
  return (
    <Polyline
      positions={[pickup, drop]}
      pathOptions={{ color: fallback ? "#94a3b8" : "#FF6B00", weight: 3, opacity: 0.75, dashArray: fallback ? "6, 8" : undefined }}
    />
  );
}
